import classNames from 'classnames';
import React from 'react';
import Box, { BoxProps } from 'ui-box';

export interface IHeadingProps extends BoxProps<any> {
  size?: 100 | 200 | 300 | 400 | 500 | 600 | 700;
}

export const Heading: React.FC<IHeadingProps> = ({
  size = 500,
  className,
  ...props
}) => {
  return (
    <Box
      is="div"
      {...props}
      className={classNames(`heading-${size}`, className)}
    />
  );
};
